// @ts-nocheck
/**
 * Pick & Mix — "kies je gratis tandpasta" na het toevoegen van een e-brush.
 *
 * Onderbreekt niets: de tandenborstel gaat gewoon in het mandje en daarna vraagt
 * deze popup welke tube erbij mag. De keuze gaat door dezelfde `addItem` als een
 * klik op de kaart, dus prijs, packgrootte en de gratis-berekening lopen exact
 * zoals ze anders ook zouden lopen — deze popup weet niets van kortingen.
 *
 * De drie tubes worden uit de kaarten in het raster gelezen en niet apart
 * gerenderd, zodat de popup niet uit de pas kan lopen met de pagina.
 */
(() => {
  if (window.PBPickMixFreeToothpaste) return;

  const INITIALIZED = 'data-pm-gift-initialized';
  const OPTION_SELECTOR = '[data-pm-gift-option]';
  const openPopups = new Set();

  const bindEscapeHandler = () => {
    if (window.__pbPickMixGiftEscapeBound) return;
    window.__pbPickMixGiftEscapeBound = true;

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || openPopups.size === 0) return;

      const openPopup = document.querySelector('[data-pm-gift-popup].is-open');
      openPopup?.pmGiftController?.decline();
    });
  };

  const money = (cents, locale, currency) => {
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(
      (Number(cents) || 0) / 100
    );
  };

  const escapeHtml = (value) =>
    String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');

  /**
   * @param {object} options
   * @param {HTMLElement} options.root
   * @param {(card: HTMLElement) => void} options.addItem
   * @param {() => number} options.getCapacity hoeveel tubes er nu gratis kunnen
   * @param {(label: string, detail?: unknown) => void} [options.debug]
   * @param {(name: string, props?: object) => void} [options.track]
   */
  function init(options) {
    const {
      root,
      addItem,
      getCapacity,
      debug = () => {},
      track = () => {}
    } = options || {};

    const popupEl = root?.querySelector('[data-pm-gift-popup]');

    // Volledig, niet half: `init` geeft dit terug als de popup uitstaat, en de
    // sectie roept daarna gewoon `reset()` aan bij elke borstel. Ontbreekt die,
    // dan gooit dat een TypeError op een pad dat juist "doe niets" hoort te zijn.
    const noop = {
      maybeOpen() {},
      reset() {},
      close() {}
    };

    if (!root || !popupEl || popupEl.getAttribute(INITIALIZED) === 'true') return noop;

    popupEl.setAttribute(INITIALIZED, 'true');
    bindEscapeHandler();

    const optionsEl = popupEl.querySelector('[data-pm-gift-options]');
    const confirmBtn = popupEl.querySelector('[data-pm-gift-confirm]');
    const descriptionEl = popupEl.querySelector('[data-pm-gift-description]');
    // De ondertitel mag `{price}` bevatten. Zo hoeft de prijs niet in de
    // sectie-instelling te staan — die zou na een prijswijziging iets anders
    // beweren dan de optiekaarten eronder.
    const descriptionTemplate = descriptionEl?.textContent ?? '';
    /** @type {Map<string, number>} variant-id → stukprijs in centen */
    const priceByVariant = new Map();
    const locale = root.dataset.locale || 'nl-NL';
    const currency = root.dataset.currency || 'EUR';

    let selectedVariantId = null;
    // Waar de focus heen moet als de popup sluit. Een element volstaat niet: de
    // knop waar de klant vandaan kwam kan intussen vervangen zijn door een
    // render (het mandje bouwt zijn regels opnieuw op) of verborgen (de
    // productpopup gaat dicht voor deze opengaat). Daarom een functie die pas
    // bij het sluiten wordt opgelost.
    let restoreFocusTo = null;
    let lastFocused = null;

    const resolveFocusTarget = () => {
      const target = typeof restoreFocusTo === 'function' ? restoreFocusTo() : restoreFocusTo;
      const fallback = lastFocused;

      for (const candidate of [target, fallback]) {
        // document.body telt niet: daar valt de focus vanzelf heen als de opener
        // verdwijnt, en hem teruggeven doet niets.
        if (candidate instanceof HTMLElement && candidate.isConnected && candidate !== document.body) {
          return candidate;
        }
      }

      return null;
    };
    // Blijft staan tot de klant een volgende borstel toevoegt: wie het cadeau
    // wegklikt hoort er niet bij elke render opnieuw mee lastiggevallen te worden.
    let declined = false;

    /**
     * De leverbare tandpastakaarten, één per variant.
     *
     * Dedupliceren is nodig omdat dezelfde tube in twee ingestelde collecties kan
     * zitten en dan twee keer in het raster staat. Zonder deze stap zou de popup
     * dezelfde tandpasta dubbel aanbieden.
     */
    const getPasteCards = () => {
      const byVariant = new Map();

      for (const card of root.querySelectorAll('[data-pm-free-paste="paste"]')) {
        const variantId = card.dataset.variantId;
        if (!variantId || card.dataset.available !== 'true') continue;
        if (!byVariant.has(variantId)) byVariant.set(variantId, card);
      }

      return [...byVariant.values()];
    };

    const setOpen = (open) => {
      popupEl.hidden = !open;
      popupEl.classList.toggle('is-open', open);
      popupEl.setAttribute('aria-hidden', open ? 'false' : 'true');

      document.documentElement.classList.toggle('pbpm-gift-open', open);
      document.body.classList.toggle('pbpm-gift-open', open);

      if (open) {
        openPopups.add(popupEl);
        window.PBOverlayStack?.push(popupEl);
      } else {
        window.PBOverlayStack?.pop(popupEl);
        openPopups.delete(popupEl);
        selectedVariantId = null;

        // Terug naar de knop waarmee de klant hier kwam. Zonder dit blijft de
        // focus op een verborgen element staan en begint Tab weer bovenaan de
        // pagina.
        resolveFocusTarget()?.focus({ preventScroll: true });

        lastFocused = null;
        restoreFocusTo = null;
      }
    };

    /**
     * De elementen die in de popup focus kunnen krijgen, in DOM-volgorde. De
     * niet-gekozen opties dragen `tabindex="-1"` — zo hoort een radiogroup zich
     * te gedragen — en vallen hier dus vanzelf buiten.
     */
    const focusables = () => {
      return Array.from(
        popupEl.querySelectorAll(
          'button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        )
      ).filter((el) => el.offsetWidth > 0 || el.offsetHeight > 0);
    };

    /**
     * Tab houdt zich binnen de popup. De markup zegt `aria-modal="true"`, dus een
     * schermlezer doet de achtergrond al weg; zonder deze val zou het toetsenbord
     * er wél doorheen lopen.
     */
    const trapFocus = (event) => {
      if (event.key !== 'Tab') return;

      const items = focusables();
      if (!items.length) return;

      const first = items[0];
      const last = items[items.length - 1];
      const active = document.activeElement;

      if (event.shiftKey && (active === first || !popupEl.contains(active))) {
        event.preventDefault();
        last.focus({ preventScroll: true });
      } else if (!event.shiftKey && active === last) {
        event.preventDefault();
        first.focus({ preventScroll: true });
      }
    };

    const syncConfirm = () => {
      if (confirmBtn) confirmBtn.disabled = !selectedVariantId;
    };

    const select = (optionEl) => {
      if (!optionEl) return;

      selectedVariantId = String(optionEl.dataset.variantId || '') || null;

      popupEl.querySelectorAll(OPTION_SELECTOR).forEach((el) => {
        const isSelected = el === optionEl;
        el.classList.toggle('is-selected', isSelected);
        el.setAttribute('aria-checked', isSelected ? 'true' : 'false');
        el.tabIndex = isSelected ? 0 : -1;
      });

      syncConfirm();
      syncDescription();
    };

    const syncDescription = () => {
      if (!descriptionEl || !descriptionTemplate.includes('{price}')) return;

      const cents = priceByVariant.get(selectedVariantId ?? '');
      descriptionEl.textContent = descriptionTemplate.replace(
        '{price}',
        money(cents ?? 0, locale, currency)
      );
    };

    const renderOptions = (cards) => {
      if (!optionsEl) return;

      priceByVariant.clear();

      optionsEl.innerHTML = cards
        .map((card) => {
          const price = Number(card.dataset.price || 0);
          priceByVariant.set(String(card.dataset.variantId), price);
          // De kleine regel boven de titel op de kaart is precies het verschil
          // dat de klant hier moet maken ("Freshmint met Fluoride"). Ontbreekt
          // die, dan valt hij terug op de producttitel.
          const name = card.dataset.cardTopText || card.dataset.productTitle || '';
          const description = card.dataset.cardSubtitle || '';
          const image = card.dataset.image || '';

          return `
            <button
              type="button"
              class="pb-pm-gift__option"
              data-pm-gift-option
              data-variant-id="${escapeHtml(card.dataset.variantId)}"
              role="radio"
              aria-checked="false"
              tabindex="-1"
            >
              <span class="pb-pm-gift__thumb">
                ${
                  image
                    ? `<img src="${escapeHtml(image)}" alt="" loading="lazy" width="96" height="96">`
                    : ''
                }
              </span>

              <span class="pb-pm-gift__copy">
                <span class="pb-pm-gift__name">${escapeHtml(name)}</span>
                ${
                  description
                    ? `<span class="pb-pm-gift__desc">${escapeHtml(description)}</span>`
                    : ''
                }
              </span>

              <span class="pb-pm-gift__price">
                <span class="pb-pm-gift__price-row">
                  <span class="pb-pm-gift__price-was">${money(price, locale, currency)}</span>
                  <span class="pb-pm-gift__price-now">${money(0, locale, currency)}</span>
                </span>
                <span class="pb-pm-gift__price-free">${escapeHtml(
                  root.dataset.freePasteLabel || 'Gratis'
                )}</span>
              </span>
            </button>
          `;
        })
        .join('');

      // De eerste staat voor: de knop is dan meteen bruikbaar en de keuze is
      // duidelijk voorgesteld in plaats van leeg.
      select(optionsEl.querySelector(OPTION_SELECTOR));
    };

    const moveSelection = (delta) => {
      const all = Array.from(popupEl.querySelectorAll(OPTION_SELECTOR));
      if (!all.length) return;

      const current = all.findIndex(
        (el) => String(el.dataset.variantId || '') === selectedVariantId
      );
      const next = all[(current + delta + all.length) % all.length];

      select(next);
      next.focus({ preventScroll: true });
    };

    const controller = {
      /**
       * Opent de popup als er nu een tube gratis bij kan.
       *
       * @param {{restoreFocusTo?: (() => HTMLElement | null) | HTMLElement | null}} [options]
       *   waar de focus heen moet bij sluiten, als `document.activeElement` op dat
       *   moment niet meer bruikbaar is.
       */
      maybeOpen({ restoreFocusTo: focusTarget = null } = {}) {
        if (declined || popupEl.classList.contains('is-open')) return;
        if ((Number(getCapacity?.()) || 0) <= 0) return;

        const cards = getPasteCards();
        if (!cards.length) {
          debug('Gratis-tandpasta popup overgeslagen: geen beschikbare tubes op de pagina');
          return;
        }

        restoreFocusTo = focusTarget;
        lastFocused = document.activeElement instanceof HTMLElement
          ? document.activeElement
          : null;

        renderOptions(cards);
        setOpen(true);

        track('opened', { options: cards.length });

        const firstOption = popupEl.querySelector(OPTION_SELECTOR);
        if (firstOption) {
          setTimeout(() => firstOption.focus({ preventScroll: true }), 0);
        }
      },

      confirm() {
        if (!selectedVariantId) return;

        const card = root.querySelector(
          `[data-pm-free-paste="paste"][data-variant-id="${CSS.escape(selectedVariantId)}"]`
        );

        const variantId = selectedVariantId;

        if (!card) {
          setOpen(false);
          debug('Gratis-tandpasta niet toegevoegd: kaart niet gevonden', variantId);
          return;
        }

        // Toevoegen vóór sluiten: `addItem` rendert opnieuw, en pas daarna staat
        // de knop waar de focus heen moet er echt.
        addItem(card);
        setOpen(false);
        track('accepted', { variant_id: variantId });
      },

      decline() {
        declined = true;
        setOpen(false);
        track('declined');
      },

      /** Een nieuwe borstel is een nieuw aanbod, dus het wegklikken vervalt. */
      reset() {
        declined = false;
      },

      close() {
        setOpen(false);
      }
    };

    popupEl.pmGiftController = controller;

    popupEl.addEventListener('keydown', trapFocus);

    popupEl.querySelectorAll('[data-pm-gift-close]').forEach((el) => {
      el.addEventListener('click', () => controller.decline());
    });

    popupEl
      .querySelector('[data-pm-gift-decline]')
      ?.addEventListener('click', () => controller.decline());

    confirmBtn?.addEventListener('click', () => controller.confirm());

    optionsEl?.addEventListener('click', (event) => {
      const optionEl = event.target.closest(OPTION_SELECTOR);
      if (optionEl) select(optionEl);
    });

    optionsEl?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
        event.preventDefault();
        moveSelection(1);
      } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
        event.preventDefault();
        moveSelection(-1);
      }
    });

    return controller;
  }

  window.PBPickMixFreeToothpaste = { init };
})();
